import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function CommunicationsTableSkeleton() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="flex flex-col bg-card">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="flex flex-col gap-1.5 border-b border-border px-4 py-2.5 last:border-0"
          >
            <div className="flex items-center gap-1.5">
              <Skeleton className="size-3.5 flex-none rounded" />
              <Skeleton className="h-3.5 flex-1" />
              <Skeleton className="h-4 w-16 flex-none rounded-[7px]" />
            </div>
            <Skeleton className="h-3 w-48" />
            <Skeleton className="h-3 w-32" />
          </div>
        ))}
      </div>
    );
  }

  // Mirrors CommunicationsTable's six columns; keep in sync if that table changes.
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-10" />
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-14" />
        <Skeleton className="h-3 w-16" />
      </div>
      {Array.from({ length: 12 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[38px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="size-3.5 flex-none rounded" />
          <Skeleton className="h-3 w-40" />
          <Skeleton className="h-3 flex-1" />
          <Skeleton className="h-3 w-28" />
          <Skeleton className="h-4 w-16 rounded-[7px]" />
          <Skeleton className="h-3 w-24" />
        </div>
      ))}
    </div>
  );
}
